

















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import { LelyApp, LelyAuth } from '@hn-work/frontend-vue-shared';

@Component({})
export default class App extends Vue {
    @State('errors')
    errors!: string[];

    @Mutation('removeErrors')
    removeErrors!: (errors: string[]) => void;

    tokenCopied = false;

    showingErrors = false;

    get loginPage(): boolean {
        return this.$route.name === 'login';
    }

    get app(): LelyApp {
        return LelyApp.HMF_ADMIN;
    }

    @Watch('errors')
    async showErrors(): Promise<void> {
        if (this.showingErrors || this.errors.length === 0) {
            return;
        }

        this.showingErrors = true;

        // Errors stay in the store while the modal is open, so duplicates arriving meanwhile are dropped
        const shown = [...this.errors];
        const messages = shown.map(err => this.$createElement('div', { class: 'alert alert-danger' }, err));

        try {
            await this.$bvModal.msgBoxOk(messages, {
                title: 'Errors',
                okTitle: 'Close',
                okVariant: 'primary',
            });
        } finally {
            this.showingErrors = false;
            this.removeErrors(shown);
        }

        // Show errors that came in while the modal was open
        await this.showErrors();
    }

    public async copyToken(): Promise<void> {
        const token = LelyAuth.getAccessToken();

        if (!token) {
            return;
        }

        // copy token to clipboard
        await navigator.clipboard.writeText(token);

        this.tokenCopied = true;
    }
}

